import { _ as _typeof } from '../typeof-cae87b03.js';

function deepCompare(object1, object2) {
  if (!(isObject(object1) && isObject(object2))) {
    return object1 === object2;
  }
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val1 = object1[key];
    var val2 = object2[key];
    var areObjects = isObject(val1) && isObject(val2);
    if (areObjects && !deepCompare(val1, val2) || !areObjects && val1 !== val2) {
      return false;
    }
  }
  return true;
}
function isObject(object) {
  return object != null && _typeof(object) === 'object';
}

export { deepCompare as default };
//# sourceMappingURL=index.js.map
